import { userInteractionAction, ViewType } from 'owa-calendar-actions';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { confirm } from 'owa-confirm-dialog';
import { isFeatureEnabled } from 'owa-feature-flags';
import loc from 'owa-localize';
import { getOpxHostApi } from 'owa-opx';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import {
    joinOnlineMeetingDialogTitle,
    joinOnlineMeetingDialogDescription,
    joinOnlineMeetingDialogCloseButtonText,
} from '../component/JoinOnlineMeetingButton.locstring.json';

const styles = require('../component/JoinOnlineMeetingButton.scss');

/**
 * Util to be used when join button is clicked
 * @param event CalendarEvent on which join is clicked
 * @param viewType ViewType of the UX
 * @param actionIfNotOpx The action to be performed if it is not OPX scenario
 */
export default function onJoinTeamsClicked(
    event: CalendarEvent,
    viewType: ViewType,
    actionIfNotOpx?: () => void
) {
    // If it's hosted in opx, then call the teams join API if possible
    if (isHostAppFeatureEnabled('joinTeamsMeeting') && getOpxHostApi().joinTeamsMeeting) {
        getOpxHostApi().joinTeamsMeeting(event);
    } else {
        // Show a dialog when the join URL is not available and prevent the user from opening the join meeting tab
        if (isFeatureEnabled('cal-mf-attendeeCollab') && !event.OnlineMeetingJoinUrl) {
            confirm(
                loc(joinOnlineMeetingDialogTitle),
                loc(joinOnlineMeetingDialogDescription),
                false,
                {
                    hideCancelButton: true,
                    okText: loc(joinOnlineMeetingDialogCloseButtonText),
                    containerClassName: styles.joinMeetingDialogConfirmation,
                }
            );
            userInteractionAction(
                'JoinOnlineMeeting',
                viewType,
                event.IsOrganizer,
                event.IsMeeting,
                ['JoinURLUnavailable']
            );
            return;
        }

        if (actionIfNotOpx) {
            actionIfNotOpx();
        }
    }

    userInteractionAction('JoinOnlineMeeting', viewType, event.IsOrganizer, event.IsMeeting, [
        event.OnlineMeetingProvider,
    ]);
}
